export default {"bugsnag":true,"bugsnagApiKey":"731b4e1a112ef50ee8a8cb6bbeb48a69","bugsnagReleaseStage":"production","zopim":true,"help_page_url":"https://support.kaizenplatform.net/hc/ja/articles/360000052822","dashboard":"https://app.kaizenplatform.net","api_base":"https://api.kaizenplatform.net","appVersion":"1.1.0","env":"production"}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/config.ts